"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAnalyticsProvider = void 0;
var tslib_1 = require("tslib");
var analytics_1 = require("firebase/analytics");
var inversify_1 = require("inversify");
var FirebaseAnalyticsProvider = (function () {
    function FirebaseAnalyticsProvider() {
    }
    FirebaseAnalyticsProvider.prototype.init = function (firebaseApp) {
        var _this = this;
        (0, analytics_1.isSupported)().then(function (supported) {
            if (supported) {
                _this.firebaseAnalytics = (0, analytics_1.getAnalytics)(firebaseApp);
            }
        });
    };
    FirebaseAnalyticsProvider.prototype.track = function (name, value, params) {
        this.logEvent(name, tslib_1.__assign({ value: value }, params));
    };
    FirebaseAnalyticsProvider.prototype.logEvent = function (event, params) {
        if (this.firebaseAnalytics) {
            (0, analytics_1.logEvent)(this.firebaseAnalytics, event, params);
        }
    };
    FirebaseAnalyticsProvider = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], FirebaseAnalyticsProvider);
    return FirebaseAnalyticsProvider;
}());
exports.FirebaseAnalyticsProvider = FirebaseAnalyticsProvider;
//# sourceMappingURL=FirebaseAnalyticsProvider.js.map